import { InformationPaneConfig } from "app/services/config/app-config";
import * as React from "react";
import { resolveInject } from "app/di";
import { ISparqlExecutor } from "app/services/infrastructure/sparql-executor";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { Grid } from "@mui/material";
import QueryResultTable from "./query-result-table";

interface IComponentProps {
    config: InformationPaneConfig;
}

interface QueryResult {
    name: string;
    data: any;
}
export const StartPage = (props: IComponentProps) => {
    const [queriesResults, setQueriesResults] = React.useState<QueryResult[]>([]);
    const { id, name, staticProperties, queries } = props.config.startPage;
    const sparqlExecutor = resolveInject(ISparqlExecutor);

    const getData = async () => {
        let results: QueryResult[] = [];
        for (let query of queries || []) {
            let result = await sparqlExecutor.execute(query.query, []);
            let q = {
                name: query.name,
                data: result
            };
            results.push(q);
        }
        setQueriesResults(results);
    };

    React.useEffect(() => {
        getData();

        return () => {
            setQueriesResults([]);
        };
    }, []);

    const renderQuery = (query: QueryResult) => {
        return (
            <QueryResultTable
                key={query.name}
                name={query.name}
                head={query.data.head.vars}
                body={query.data.results.bindings}
            />
        );
    };

    const renderRow = (key: string, value: string, disableBorder?: boolean) => {
        return (
            <Grid container key={key} spacing={2} sx={{ paddingTop: 1 }}>
                <Grid
                    size={4}
                    sx={{
                        textTransform: "uppercase",
                        p: 0,
                        borderBottom: disableBorder ? "none" : "2px solid"
                    }}
                >
                    {key}
                </Grid>
                <Grid size={8}>{value}</Grid>
            </Grid>
        );
    };

    return (
        <Card id={id} elevation={0}>
            <CardHeader title={name} sx={{ padding: 2 }} />
            <CardContent sx={{ padding: 0 }}>
                {staticProperties && staticProperties.map((p) => renderRow(p.name, p.value))}
                {queriesResults && queriesResults.map(renderQuery)}
            </CardContent>
        </Card>
    );
};
